import { getGuid } from 'owa-guid';

let fallBackDeviceId: string | null = null;
export function getFallBackDeviceId(): string {
    if (!fallBackDeviceId) {
        fallBackDeviceId = getGuid();
    }
    return fallBackDeviceId;
}
